import e, { useMemo as A, useEffect as C } from "react";
import { Search as L } from "./index27.mjs";
import { Checkout as _ } from "./index28.mjs";
import { useAtomValue as n, useSetAtom as c } from "jotai/index";
import { getStepAtom as v, setCurrentStepAtom as h, getOpenSummaryModalAtom as M, setOpenSummaryModalAtom as N } from "./index25.mjs";
import { BookingSummary as I } from "./index29.mjs";
import { FinalStep as b } from "./index30.mjs";
import { Toasts as U } from "./index31.mjs";
import { Alert as w } from "./index32.mjs";
import t from "./index33.mjs";
import { cartItemsAtom as F, giftCardsAtom as O } from "./index34.mjs";
import { getConfigPropertyAtomCreator as R, ConfigProperty as V, ViewLayout as s } from "./index13.mjs";
import { AlertModal as B } from "./index35.mjs";
import p from "classnames";
import { Modal as P } from "./index36.mjs";
import { BookingSummaryContent as D } from "./index37.mjs";
import { ItemSelection as T } from "./index38.mjs";
const u = (r) => {
  r.preventDefault(), r.returnValue = !0;
}, oe = ({
  isExpanded: r,
  onClose: m,
  setIsExpanded: f,
  roomId: d
}) => {
  const o = n(v), a = c(h), l = n(
    A(() => R(V.VIEW_LAYOUT), [])
  ), E = n(F), S = n(O), y = n(M), g = c(N);
  C(() => (o > 0 && addEventListener("beforeunload", u), () => {
    removeEventListener("beforeunload", u);
  }), [o]);
  const k = () => {
    a(0);
  }, i = [
    /* @__PURE__ */ e.createElement(
      L,
      {
        key: "search-step",
        onClose: m,
        onSearchClick: () => {
          a(1);
        }
      }
    ),
    /* @__PURE__ */ e.createElement(
      T,
      {
        key: "results-step",
        isExpanded: r,
        setIsExpanded: f,
        onClose: m,
        onEditDates: k,
        roomId: d
      }
    ),
    /* @__PURE__ */ e.createElement(_, { onClose: m, key: "checkout-step" }),
    /* @__PURE__ */ e.createElement(b, { onClose: m, key: "final-step" })
  ];
  return i[o] ? /* @__PURE__ */ e.createElement("div", { className: t.container }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: p(t.wrapper, {
        [t["wrapper-full-screen"]]: l === s.FULL_SCREEN
      }),
      "data-testid": "booking-engine-steps"
    },
    l === s.FULL_SCREEN ? /* @__PURE__ */ e.createElement(B, null) : /* @__PURE__ */ e.createElement(w, null),
    y && (E.length > 0 || S.length > 0) ? /* @__PURE__ */ e.createElement(
      P,
      {
        title: I18n.t("online_check_in.your_booking_details"),
        onClose: () => g(!1)
      },
      /* @__PURE__ */ e.createElement(D, { displaysInsideModal: !0 })
    ) : null,
    /* @__PURE__ */ e.createElement("div", { className: t.steps_container }, i[o]),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: p(t.footer, {
          [t["footer-full-screen"]]: l === s.FULL_SCREEN
        })
      },
      /* @__PURE__ */ e.createElement(U, null),
      /* @__PURE__ */ e.createElement(
        I,
        {
          setCurrentStep: a,
          currentStep: o,
          isSidePanelExpanded: r
        }
      )
    )
  )) : null;
};
export {
  oe as BookingEngineSteps,
  oe as default
};
